export function setDocumentTitle(title?: string | null) {
  document.title = title ? `Evisort | ${title}` : 'Evisort';
}

/** A valid window.opener is that exists and is of SAME origin */
export function testIsValidWindowOpener() {
  try {
    return Boolean(window.opener?.location.href);
  } catch {
    return false; // i.e. cross-origin error
  }
}
